import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Category from "@/pages/category/page";
import Article from "@/pages/article/page";
import About from "@/pages/about/page";
import Layout from "@/components/feature/Layout";

const routes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/category/:slug",
        element: <Category />,
      },
      {
        path: "/article/:id",
        element: <Article />,
      },
      {
        path: "/about",
        element: <About />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;